'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var processChangePassword = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(props) {
    var auth, setStage, newPassword, oldPassword, confirmPassword, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = props.auth, setStage = props.setStage, newPassword = props.newPassword, oldPassword = props.oldPassword, confirmPassword = props.confirmPassword;
            _context.prev = 1;

            if (!(newPassword !== confirmPassword)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return', setStage('fail:confirm'));

          case 4:

            setStage('fetching');
            _context.next = 7;
            return auth.changePassword(oldPassword, newPassword);

          case 7:
            response = _context.sent;

            setStage('success');
            // TODO reset user?
            // TODO redirect to Menu?
            return _context.abrupt('return', response);

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](1);

            console.error('processChangePassword: ', _context.t0);
            setStage('fail:change');
            throw _context.t0;

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 12]]);
  }));

  return function processChangePassword(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setPropTypes = require('recompose/setPropTypes');

var _setPropTypes2 = _interopRequireDefault(_setPropTypes);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _Password = require('./Password');

var _Password2 = _interopRequireDefault(_Password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var messageSet = {
  init: {},
  fetching: {
    message: '修改密碼中...',
    messageStyle: 'info'
  },
  success: {
    message: '密碼修改成功',
    messageStyle: 'success'
  },
  'fail:confirm': {
    message: '新密碼與確認密碼不符',
    messageStyle: 'danger'
  },
  'fail:change': {
    message: '舊密碼錯誤',
    messageStyle: 'danger'
  },
  error: {
    message: '狀態異常!請檢查網路連線或與維護人員連絡',
    messageStyle: 'danger'
  }
};

var shape = _propTypes2.default.shape,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object;

var enhancer = (0, _compose2.default)((0, _setPropTypes2.default)({
  auth: shape({
    login: func.isRequired,
    user: object.isRequired
  }),
  history: shape({
    push: func.isRequired
  })
}), (0, _withState2.default)('oldPassword', 'setOldPassword', ''), (0, _withState2.default)('newPassword', 'setNewPassword', ''), (0, _withState2.default)('confirmPassword', 'setConfirmPassword', ''), (0, _withState2.default)('stage', 'setStage', 'init'), (0, _withHandlers2.default)({
  changePassword: function changePassword(props) {
    return function () {
      return processChangePassword(props);
    };
  }
}), (0, _withProps2.default)(function (_ref2) {
  var stage = _ref2.stage;
  return _extends({}, messageSet[stage]);
}));

exports.default = enhancer(_Password2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Password/index.js
// module id = 1265
// module chunks = 0